import useMaskedCardNumber from "@/hooks/useMaskedCardNumber";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import OtpInput from "@/shared/components/common/otp";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Dispatch, SetStateAction } from "react";

interface OtpTabProps {
  dataPhone: any;
  valueOtp: string;
  setValueOtp: Dispatch<SetStateAction<string>>;
  handleSubmit?: () => void;
  onResendOtp?: () => void;
  isResendingOtp?: boolean;
  otpMessage?: string;
  otpStatus?: string;
  timeLeft?: number;
  isWaitingForOtp?: boolean;
}

const OtpTab = ({
                  dataPhone,
                  valueOtp,
                  setValueOtp,
                  handleSubmit,
                  onResendOtp,
                  isResendingOtp,
                  otpMessage,
                  otpStatus,
                  timeLeft,
                  isWaitingForOtp
                }: OtpTabProps) => {
  const maskedPhoneNumber = useMaskedCardNumber(dataPhone);

  return (
      <StackKit sx={{ width: "100%", height: "100%" }} direction={"row"} justifyContent={"center"} alignItems={"center"}>
        <StackKit direction={"column"} sx={{ width: "80%", minHeight: "400px" }} alignItems={"center"}>
          <TypoGraphyKit variant="h6" sx={{ minHeight: "100px" }}>
            در این مرحله یک کد امنیتی جهت اعتبار سنجی برای شماره تماس{" "}
            {toPersianNumber(maskedPhoneNumber)} ، ارسال میشود. لطفا کد ارسال شده را وارد نمایید.
          </TypoGraphyKit>

          {otpMessage && (
              <TypoGraphyKit variant="body2" color={otpStatus === 'error' ? 'error' : 'info'} sx={{ mb: 2 }}>
                {otpMessage}
              </TypoGraphyKit>
          )}

          <BoxKit sx={{ width: "60%" }}>
            <OtpInput
                length={5}
                hasResend
                value={valueOtp}
                onChange={setValueOtp}
                handleSubmit={handleSubmit}
                onResend={onResendOtp}
            />
          </BoxKit>
        </StackKit>
      </StackKit>
  );
};

export default OtpTab;